import { Card } from 'react-bootstrap'
import Kshitiz from '../../assets/images/fodc/Kshitiz.png'
import Priyam from '../../assets/images/fodc/Priyam.png'
import Brandon from '../../assets/images/fodc/Brandon.png'
import LinkExternal from '../../assets/images/fodc/Vector.svg'
import { Link } from 'react-router-dom'

const Section4 = ({ refProp }) => {
    const cards = [
        {
          name: 'Kshitiz',
          title: 'Co-founder, Financial Reconciliation Expert',
          image: Kshitiz,
          alt: 'Kshitiz_profile',
          link: 'https://calendly.com/kshitizsanghi/meeting'
        },
        {
          name: 'Priyam',
          title: 'Co-founder, Customer Reviews & Store Downtime Expert',
          image: Priyam,
          alt: 'Priyam_profile',
          link: 'https://calendly.com/priyamsaraswat/30min'
        },
        {
          name: 'Brandon',
          title: 'Director of Sales, Order Dispute & Ops Expert',
          image: Brandon,
          alt: 'Brandon_profile',
          link: 'https://meetings.hubspot.com/brandon1142?uuid=40f5e994-fce3-47a6-9fed-b237b77b85dd'
        }
      ];
  return (
    <>
    <div className='fodc-s4 m-auto' ref={refProp}>
        <p className='fodc-p-text mb-0'>Meet our team at FODC</p>
        <p className='fodc-fs-40 mb-0' style={{opacity:'50%'}}>(May 5-7, 2025)</p>
        <p className='fodc-md-text m-pt-14'>Take <span className='color-brand'>Brandon, Priyam, or Kshitiz</span> out for coffee (on us!) ☕️</p>
        <div className="carousel-wrapper">
            <div className="carousel">
                {cards.map((card, index) => (
                <div className="carousel-card" key={index}>
                    <Card className="border-0">
                    <Card.Img variant="top" src={card.image} alt={card.alt} />
                    <Card.Body className="p-0 text-center">
                        <Card.Title className="mt-4">{card.name}</Card.Title>
                        <Card.Text className="mb-4 w-75 m-auto" style={{ opacity: '50%' }}>
                        {card.title}
                        </Card.Text>
                        <Link to={card.link} rel='noreferrer' target='_blank' ><div className='btn btn-dark w-100' style={{borderRadius:'0'}}>Book a call</div></Link>
                    </Card.Body>
                    </Card>
                </div>
                ))}
            </div>
        </div>
        <div className='d-flex justify-content-between my-5'>
            <p className='fodc-fs-40 w-75 color-brand mb-0'>No need for a full team <span style={{opacity:'50%'}}>to manage third-party platforms</span><span className='text-black'>—just one Voosh.</span></p>
            <Link to={'/'} reloadDocument><img className='link-ext-logo' src={LinkExternal} alt='link-external-icon' /></Link>
        </div>
    </div>
    
    </>
  )
}

export default Section4